export const useImageListData = () => {
  const config = useRuntimeConfig()
  const transform = (response) => {
    const { sanitize } = useUtils();

    return {
      imageList: sanitize(response.data.attributes.imageList),
    }
  }    
  const getImageList = async (deep = true) => {        
    const url = `/api/image-list`;
    
    return await useFetch(url, {
      method: 'GET',
      transform: transform
    });
  }
    
    return {
      getImageList,
    }
}